<template>
    <ai-grid-ro
        ref="gridRoRef"
        :meta="meta"
        :args="args"
        :to-remove-toolbar-items-names="[]"
        :auto-load-data="false"
        @select-click="onSelectClick"
        @toolbar-button-click="toolbarButtonClick"
    />
</template>
<script setup>
import AiGridRo from '@/components/ai-grid-ro/ai-grid-ro.vue';
import { ref } from 'vue';

const gridRoRef = ref();
const emit = defineEmits(['dictionarySelectionChanged']);
const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    args: {
        type: Object,
        default: () => {},
    },
    rowClickCallBack: {
        type: Function,
        default: () => {},
    },
});

const onSelectClick = e => {
    if (props.rowClickCallBack) {
        props.rowClickCallBack({ row: e[0], keyExpr: props.meta.keyExpr });
    }
    emit('dictionarySelectionChanged', e[0]);
};
const toolbarButtonClick = e => {
    if (e.item.component.name === 'choice') {
        const rowsData = e.data?.selectedRows;
        emit('dictionarySelectionChanged', rowsData);
    }
};
defineExpose({
    gridRoRef,
});
</script>
